import { ViewOpeningsByOptions } from '../../../types';

export const PATIENT_STATUSES = [
  {
    id: 'NEW',
    display: 'New Patient',
  },
  {
    id: 'RETURNING',
    display: 'Returning Patient',
  },
];

export const VIEW_OPENINGS_BY_OPTIONS: { [type in ViewOpeningsByOptions] } = {
  OFFICE: 'OFFICE',
  PROVIDER: 'PROVIDER',
};
